// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3nYtO","calendarButtons":"ClockData_calendarButtons__1_nU7"};